// extracted by mini-css-extract-plugin
export var label = "_f6-2";
export var slideContainer = "_f6-0";
export var slider = "_f6-1";